export default "\n文档可在 <https://doc.dezrann.net> 查阅英文版本，为贡献者和开发者提供指导，涵盖语料库集成（数据格式、语料库创建、管理、质量评估和维护）、翻译与本地化，以及前端和后端的开发者信息。";